
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import AppLayout from "@/layouts/AppLayout.vue";
import { AxiosResponse } from "axios";
import $ from "jquery";
import toast from "@/functions/toast.function";
import moment from "moment";
import {
  getCandidateToken,
  setCandidateToken,
} from "@/functions/token.function";
import {
  AdminJobFairPartnerGroupSizeEnum,
  AdminJobFairAuthorizationEnum,
  AdminJobFairTransactionCategoryEnum,
  EnumHelper,
  AdminJobFairTypeEnum,
} from "@/constants/enum.constant";
import ScanQr from "@/components/ScanQr.vue";
import Loading from "@/components/Loading.vue";
import { isEmail } from "@/functions/global.function";

@Component({
  components: {
    Loading,
    ScanQr,
    AppLayout,
  },
  filters,
})
export default class JobFairDetail extends Vue {
  @Action("getSchoolType", { namespace: "admin" })
  private getSchoolType: any;
  @Action("getAdminJobFairDetail", { namespace: "admin" })
  private getAdminJobFairDetail: any;
  @Action("buyCheckAdminJobFair", { namespace: "admin" })
  private buyCheckAdminJobFair: any;
  @Action("buyAdminJobFair", { namespace: "admin" })
  private buyAdminJobFair: any;
  @Action("adminJobFairCandidateSendOtp", { namespace: "admin" })
  private adminJobFairCandidateSendOtp: any;
  @Action("adminJobFairCandidateLoginCheck", { namespace: "admin" })
  private adminJobFairCandidateLoginCheck: any;
  @Action("adminJobFairCandidateLogin", { namespace: "admin" })
  private adminJobFairCandidateLogin: any;
  @Action("getAdminJobFairCandidateProfile", { namespace: "admin" })
  private getAdminJobFairCandidateProfile: any;
  @Action("getAdminJobFairCompany", { namespace: "admin" })
  private getAdminJobFairCompany: any;
  @Action("getGeneralDegree", { namespace: "admin" })
  private getGeneralDegree: any;
  @Action("getGeneralMajor", { namespace: "admin" })
  private getGeneralMajor: any;

  @State("locale")
  private locale!: string;
  @State("candidate", { namespace: "admin" })
  private candidate!: any;

  private jobFair: any = null;
  private schoolTypes: Array<any> = [];
  private companies: Array<any> = [];
  private degrees: Array<any> = [];
  private majors: Array<any> = [];
  private step = 1;
  private stepLogin = 1;
  private name = "";
  private email = "";
  private phone = "";
  private birthday = "";
  private schoolName = "";
  private endYear = "";
  private otp = "";
  private timeUntilReSendOtp = 0;
  private otpTimer = "";
  private isReSendOtp = false;
  private schoolType: any = null;
  private degree: any = null;
  private major: any = null;
  private category: any = null;
  private cv: any = null;
  private page = 1;
  private isLastPage = false;
  private isLoadingJobFair = false;
  private isLoadingCompany = false;
  private isEmailDoesntExist = false;
  private interval: any = null;
  private sizes = EnumHelper(AdminJobFairPartnerGroupSizeEnum);

  @Watch("degree")
  private onDegree() {
    this.majors = [];
    this.major = null;

    if (this.degree?.id) {
      this.getGeneralMajor({
        params: {
          degree: this.degree?.id,
        },
        success: (response: AxiosResponse) => {
          this.majors = response.data.data;
        },
      });
    }
  }

  private get categories() {
    return EnumHelper(AdminJobFairTransactionCategoryEnum).map((value) => ({
      ...value,
      translation: this.$t(`category_${value.name.toLowerCase()}`, {
        organizer: this.jobFair?.organizer_name,
      }),
    }));
  }

  private get isEn() {
    return this.locale === "en";
  }

  private get canReSendOtp() {
    return this.timeUntilReSendOtp === 0;
  }

  private get isJobFairStarted() {
    if (this.jobFair)
      return moment(moment()).utc().isSameOrAfter(this.jobFair.start_date);
    else return false;
  }
  private get isJobFairEnded() {
    if (this.jobFair)
      return moment(moment()).utc().isSameOrAfter(this.jobFair.end_date);
    else return false;
  }
  private get isOneDay() {
    return moment(this.jobFair?.start_date).isSame(
      this.jobFair?.end_date,
      "day"
    );
  }

  private get canRegister() {
    return this.jobFair?.authorizations?.find(
      (value) => value.code === AdminJobFairAuthorizationEnum.REGISTER
    )?.is_allowed;
  }
  private get canLogin() {
    return this.jobFair?.authorizations?.find(
      (value) => value.code === AdminJobFairAuthorizationEnum.LOGIN
    )?.is_allowed;
  }
  private get canAutoLogin() {
    return this.jobFair?.authorizations?.find(
      (value) => value.code === AdminJobFairAuthorizationEnum.AUTO_LOGIN
    )?.is_allowed;
  }

  private created() {
    this.getData();
  }

  private beforeDestroy() {
    clearInterval(this.interval);
  }

  private afterData() {
    if (this.$route.query && this.$route.query.token) {
      setCandidateToken(this.$route.query.token.toString());
      this.$router.push({
        name: "job-fair-detail",
        params: this.$route.params,
      });
    }
    if (this.$route.query && this.$route.query.email) {
      this.email = this.$route.query.email.toString();
      this.$bvModal.show("modal-login-otp");
    }

    if (getCandidateToken())
      this.getAdminJobFairCandidateProfile({
        params: {
          slug: this.$route.params.slug,
        },
        success: (response: AxiosResponse) => {
          if (response.data) {
            this.websocketAttendance();
            this.websocketCategory();
            this.websocketDaily();
            this.websocketDailyAttendance();
          }
        },
      });
    this.getSchoolType({
      success: (response: AxiosResponse) => {
        this.schoolTypes = response.data.data;
      },
    });
    this.getGeneralDegree({
      success: (response: AxiosResponse) => {
        this.degrees = response.data.data;
      },
    });
    this.getCompanyData();
  }

  private showModalRegister() {
    if (this.canRegister) this.$bvModal.show("modal-registration");
    else toast.warning("Pendaftaran peserta sedang ditutup.");
  }

  private showModalLogin() {
    if (this.canLogin) this.$bvModal.show("modal-login");
    else toast.warning("Check In peserta sedang ditutup.");
  }

  private getCompanyData(isReload: boolean = false) {
    if (isReload) {
      this.companies = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoadingCompany && !this.isLastPage) {
      this.isLoadingCompany = true;
      this.getAdminJobFairCompany({
        params: {
          slug: this.$route.params.slug,
          page: this.page,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.companies = [...this.companies, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
        finally: () => {
          this.isLoadingCompany = false;
        },
      });
    }
  }

  private leadingZeros(num: number, totalLength: number = 2) {
    return String(num).padStart(totalLength, "0");
  }

  private otpCountdown() {
    if (!this.canReSendOtp) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      let m = this.leadingZeros(Math.floor(this.timeUntilReSendOtp / 60));
      let s = this.leadingZeros(this.timeUntilReSendOtp % 60);
      this.otpTimer = m + ":" + s;
      this.timeUntilReSendOtp--;
      setTimeout(function () {
        self.otpCountdown();
      }, 1000);
      return;
    }
  }

  private getData() {
    this.isLoadingJobFair = true;
    this.getAdminJobFairDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.jobFair = response.data.data;

        switch (this.jobFair.type) {
          case AdminJobFairTypeEnum.ORGANIZATION:
          case AdminJobFairTypeEnum.COMPANY:
            this.categories.splice(0, 2);
            this.category = this.categories[0];
            break;
          case AdminJobFairTypeEnum.SCHOOL_INTERNAL:
            this.categories.splice(-1, 1);
            break;
        }

        if (this.$route.query?.from === "qr") {
          if (getCandidateToken() || this.isJobFairEnded)
            this.$router.push({
              name: "job-fair-detail",
              params: this.$route.params,
            });
          else {
            this.interval = setInterval(() => {
              if (!this.isLoadingJobFair && !this.isLoadingCompany) {
                if (this.isJobFairStarted) this.$bvModal.show("modal-welcome");
                else {
                  if (this.canRegister)
                    this.$bvModal.show("modal-registration");
                  else
                    this.$router.push({
                      name: "job-fair-detail",
                      params: this.$route.params,
                    });
                }
                clearInterval(this.interval);
              }
            }, 100);
          }
        }

        this.afterData();
      },
      fail: () => {
        this.$router.push({
          name: "not-found",
        });
      },
      finally: () => {
        this.isLoadingJobFair = false;
      },
    });
  }

  private pdfToggle(partner: any) {
    if (partner) $("#pdf-frame").attr("src", partner.attachment);
    $(".pdf-popup").toggleClass("d-none");
    $(".modal-backdrop").toggleClass("d-none");
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private resetRegistration() {
    this.step = 1;
    this.name = "";
    this.email = "";
    this.phone = "";
    this.birthday = "";
    this.schoolName = "";
    this.endYear = "";
    this.otp = "";
    this.schoolType = null;
    this.major = null;
    this.category = null;
  }

  private prev() {
    this.step--;
  }

  private prevLogin() {
    this.stepLogin--;
  }

  private getExt(name: string, separator: string = ".") {
    const separatedName = name.split(separator);
    return separatedName[separatedName.length - 1];
  }

  private validate(field) {
    switch (field) {
      case "name":
        if (!this.name) {
          toast.warning(
            this.isEn
              ? "Please enter applicant name"
              : "Silahkan masukkan nama peserta"
          );
          return false;
        }
        return true;
      case "email":
        if (!this.email) {
          toast.warning(
            this.isEn
              ? "Please enter applicant email"
              : "Silahkan masukkan alamat email peserta"
          );
          return false;
        }
        if (!isEmail(this.email)) {
          toast.warning(
            this.isEn
              ? "Please use the correct format for applicant email"
              : "Silahkan gunakan format email peserta yang sesuai"
          );
          return false;
        }
        return true;
      case "phone":
        if (!this.phone) {
          toast.warning(
            this.isEn
              ? "Please enter phone number"
              : "Silahkan masukkan nomor telepon"
          );
          return false;
        }
        if (
          this.phone.replace("+62", "0").length < 9 ||
          this.phone.replace("+62", "0").length > 13
        ) {
          toast.warning(
            this.isEn
              ? "Please use the correct format for applicant phone number (9-13 digits)"
              : "Silahkan gunakan format nomor telepon peserta yang sesuai (9-13 digit)"
          );
          return false;
        }
        return true;
      case "birthday":
        if (!this.birthday) {
          toast.warning(
            this.isEn
              ? "Please enter applicant date of birth"
              : "Silahkan masukkan tanggal lahir peserta"
          );
          return false;
        }
        if (moment().diff(this.birthday, "days") < 365 * 15) {
          toast.warning(
            this.isEn
              ? "Job fair applicant must be at least 15 years old"
              : "Peserta job fair harus berusia paling tidak 15 tahun"
          );
          return false;
        }
        return true;
      case "schoolType":
        if (!this.schoolType) {
          toast.warning(
            this.isEn
              ? "Please select applicant graduate"
              : "Silahkan pilih lulusan asal peserta"
          );
          return false;
        }
        return true;
      case "degree":
        if (!this.degree) {
          toast.warning(
            this.isEn
              ? "Please select applicant degree"
              : "Silahkan pilih tingkatan asal peserta"
          );
          return false;
        }
        return true;
      case "major":
        if (!this.major) {
          toast.warning(
            this.isEn
              ? "Please select applicant major"
              : "Silahkan pilih jurusan asal peserta"
          );
          return false;
        }
        return true;
      case "category":
        if (!this.category) {
          toast.warning(
            this.isEn
              ? "Please select applicant category"
              : "Silahkan pilih kategori peserta"
          );
          return false;
        }
        return true;
      case "schoolName":
        if (!this.schoolName) {
          toast.warning(
            this.isEn
              ? "Please select applicant school"
              : "Silahkan pilih sekolah asal peserta"
          );
          return false;
        }
        return true;
      case "endYear":
        if (!this.endYear) {
          toast.warning(
            this.isEn
              ? "Please select applicant graduate year"
              : "Silahkan pilih tahun lulusan peserta"
          );
          return false;
        }
        if (parseInt(this.endYear) < 1970) {
          toast.warning(
            this.isEn
              ? "Graduation year cannot be before 1970"
              : "Tahun kelulusan tidak boleh kurang dari 1970"
          );
          return false;
        }
        if (parseInt(this.endYear) > moment().add(5, "years").year()) {
          toast.warning(
            this.isEn
              ? "Participant's graduation year can't be more than five years from now."
              : "Tahun kelulusan tidak boleh lebih dari lima tahun ke depan."
          );
          return false;
        }
        return true;
      case "cv": {
        if (!this.cv) {
          toast.warning(this.isEn ? "Please upload CV" : "Silahkan unggah CV");
          return false;
        }
        let ext = this.getExt(this.cv?.name);
        const extensions = [
          "pdf",
          "jpg",
          "jpeg",
          "png",
          "bmp",
          "gif",
          "svg",
          "webp",
          "doc",
          "docx",
          "zip",
          "rar",
        ];
        if (!extensions.includes(ext.toLowerCase())) {
          toast.warning(
            this.isEn
              ? `Please upload file with the correct format (${extensions.join(
                  ", "
                )})`
              : `Silahkan unggah file dengan format yang sesuai (${extensions.join(
                  ", "
                )})`
          );
          return false;
        }
        if (Math.round(this.cv?.size / 1024) > 10240) {
          toast.warning(
            this.isEn
              ? "The maximum file size that can be uploaded is 10MB"
              : "Ukuran file yang dapat diunggah maksimum 10MB"
          );
          return false;
        }
        return true;
      }
    }
  }

  private next() {
    if (this.step === 1) {
      if (!this.validate("name")) return false;
      if (!this.validate("email")) return false;
      if (!this.validate("phone")) return false;
      this.step++;
    } else if (this.step === 2) {
      if (!this.validate("birthday")) return false;
      if (!this.validate("schoolType")) return false;
      if (!this.validate("degree")) return false;
      if (!this.validate("major")) return false;
      if (!this.validate("category")) return false;
      if (!this.validate("schoolName")) return false;
      if (!this.validate("endYear")) return false;
      // if (!this.validate("cv")) return false;
      const formData = new FormData();
      formData.append("id", this.jobFair?.id);
      formData.append("name", this.name);
      formData.append("email", this.email.toLowerCase());
      formData.append("phone", this.phone);
      formData.append("birthday", this.birthday);
      formData.append("school_name", this.schoolName);
      formData.append("end_year", this.endYear);
      formData.append("school_type_id", this.schoolType?.id);
      formData.append("degree", this.degree?.translation);
      formData.append("major", this.major?.translation);
      formData.append("category", this.category?.id);
      // formData.append("cv", this.cv);
      this.buyCheckAdminJobFair({
        params: formData,
        success: () => {
          this.sendOtp(true);
          this.step++;
        },
      });
    } else if (this.step === 3) {
      if (!this.otp) {
        toast.warning(
          this.isEn
            ? `Please enter ${this.isJobFairStarted ? "PIN" : "OTP"} code`
            : `Silahkan masukkan kode ${this.isJobFairStarted ? "PIN" : "OTP"}`
        );
        return false;
      }
      if (this.otp.length < 6) {
        toast.warning(
          this.isEn
            ? `${this.isJobFairStarted ? "PIN" : "OTP"} code should be 6 digits`
            : `Kode ${this.isJobFairStarted ? "PIN" : "OTP"} harus 6 digit`
        );
        return false;
      }
      const formData = new FormData();
      formData.append("id", this.jobFair?.id);
      formData.append("name", this.name);
      formData.append("email", this.email.toLowerCase());
      formData.append("phone", this.phone);
      formData.append("birthday", this.birthday);
      formData.append("school_name", this.schoolName);
      formData.append("end_year", this.endYear);
      formData.append("school_type_id", this.schoolType?.id);
      formData.append("degree", this.degree?.translation);
      formData.append("major", this.major?.translation);
      formData.append("category", this.category?.id);
      // formData.append("cv", this.cv);
      formData.append("otp", this.otp);
      this.buyAdminJobFair({
        params: formData,
        success: (response: AxiosResponse) => {
          if (response.data.data.invoice.url)
            window.open(response.data.data.invoice.url, "_self");
          else {
            this.step++;
            if (response.data.data.token)
              this.setToken(response.data.data.token);
          }

          this.websocketAttendance();
          this.websocketCategory();
          this.websocketDaily();
          this.websocketDailyAttendance();
        },
      });
    } else if (this.step === 4) {
      this.resetRegistration();
    }
  }

  private sendOtp(isRegister) {
    if (this.canReSendOtp && !this.isJobFairStarted) {
      if (!this.validate("email")) return false;
      this.adminJobFairCandidateSendOtp({
        params: {
          id: this.jobFair?.id,
          name: this.name,
          email: this.email,
          is_register: isRegister,
        },
        success: (response: AxiosResponse) => {
          if (response.data && this.stepLogin === 2) this.stepLogin++;
          this.isReSendOtp = true;
          this.timeUntilReSendOtp = 90;
          this.otpCountdown();
        },
      });
    }
  }

  private setToken(token) {
    if (this.canAutoLogin) {
      setCandidateToken(token);
      this.getAdminJobFairCandidateProfile({
        params: {
          slug: this.$route.params.slug,
        },
        success: (response: AxiosResponse) => {
          if (response.data) {
            this.websocketAttendance();
            this.websocketCategory();
            this.websocketDaily();
            this.websocketDailyAttendance();
          }
        },
      });
    }
  }

  private websocketAttendance() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "attendance",
      })
    );
  }

  private websocketCategory() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "category",
      })
    );
  }

  private websocketDaily() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "daily",
      })
    );
  }

  private websocketDailyAttendance() {
    (window as any).socket.send(
      JSON.stringify({
        slug: this.$route.params.slug,
        chart: "daily-attendance",
      })
    );
  }

  private login() {
    if (!this.otp) {
      toast.warning(
        this.isEn
          ? `Please enter ${this.isJobFairStarted ? "PIN" : "OTP"} code`
          : `Silahkan masukkan kode ${this.isJobFairStarted ? "PIN" : "OTP"}`
      );
      return false;
    }
    if (this.otp.length < 6) {
      toast.warning(
        this.isEn
          ? `${this.isJobFairStarted ? "PIN" : "OTP"} code should be 6 digits`
          : `Kode ${this.isJobFairStarted ? "PIN" : "OTP"} harus 6 digit`
      );
      return false;
    }
    this.adminJobFairCandidateLogin({
      params: {
        slug: this.$route.params.slug,
        email: this.email.toLowerCase(),
        otp: this.otp,
      },
      success: (response: AxiosResponse) => {
        if (response.data) {
          this.stepLogin = 1;
          this.email = "";
          this.otp = "";

          setCandidateToken(response.data.data);
          this.getAdminJobFairCandidateProfile({
            params: {
              slug: this.$route.params.slug,
            },
            success: (response: AxiosResponse) => {
              if (response.data) {
                this.websocketAttendance();
                this.websocketCategory();
                this.websocketDaily();
                this.websocketDailyAttendance();
              }
            },
          });

          this.$bvModal.hide("modal-welcome");
          this.$bvModal.hide("modal-login");
          this.$bvModal.hide("modal-login-otp");
        }
      },
    });
  }

  private showModalLoginOtp() {
    this.isEmailDoesntExist = false;
    if (!this.validate("email")) return false;
    this.adminJobFairCandidateLoginCheck({
      params: {
        slug: this.$route.params.slug,
        email: this.email.toLowerCase(),
      },
      success: () => {
        this.sendOtp(false);
        this.$bvModal.show("modal-login-otp");
      },
      fail: () => {
        this.isEmailDoesntExist = true;
      },
    });
  }
  private showModalRegistrationOtp() {
    if (!this.validate("name")) return false;
    if (!this.validate("email")) return false;
    if (!this.validate("phone")) return false;
    if (!this.validate("birthday")) return false;
    if (!this.validate("schoolType")) return false;
    if (!this.validate("major")) return false;
    if (!this.validate("category")) return false;
    if (!this.validate("schoolName")) return false;
    if (!this.validate("endYear")) return false;
    this.sendOtp(true);
    this.$bvModal.show("modal-registration-otp");
  }

  private buyCheck() {
    if (!this.validate("name")) return false;
    if (!this.validate("email")) return false;
    if (!this.validate("phone")) return false;
    if (!this.validate("birthday")) return false;
    if (!this.validate("schoolType")) return false;
    if (!this.validate("degree")) return false;
    if (!this.validate("major")) return false;
    if (!this.validate("category")) return false;
    if (!this.validate("schoolName")) return false;
    if (!this.validate("endYear")) return false;
    // if (!this.validate("cv")) return false;
    const formData = new FormData();
    formData.append("id", this.jobFair?.id);
    formData.append("name", this.name);
    formData.append("email", this.email.toLowerCase());
    formData.append("phone", this.phone);
    formData.append("birthday", this.birthday);
    formData.append("school_name", this.schoolName);
    formData.append("end_year", this.endYear);
    formData.append("school_type_id", this.schoolType?.id);
    formData.append("degree", this.degree?.translation);
    formData.append("major", this.major?.translation);
    formData.append("category", this.category?.id);
    // formData.append("cv", this.cv);
    this.buyCheckAdminJobFair({
      params: formData,
      success: () => {
        this.showModalRegistrationOtp();
      },
    });
  }

  private buyFromModal() {
    const formData = new FormData();
    formData.append("id", this.jobFair?.id);
    formData.append("name", this.name);
    formData.append("email", this.email.toLowerCase());
    formData.append("phone", this.phone);
    formData.append("birthday", this.birthday);
    formData.append("school_name", this.schoolName);
    formData.append("end_year", this.endYear);
    formData.append("school_type_id", this.schoolType?.id);
    formData.append("degree", this.degree?.translation);
    formData.append("major", this.major?.translation);
    formData.append("category", this.category?.id);
    // formData.append("cv", this.cv);
    formData.append("otp", this.otp);
    this.buyAdminJobFair({
      params: formData,
      success: (response: AxiosResponse) => {
        if (response.data.data.invoice.url)
          window.open(response.data.data.invoice.url, "_self");
        else {
          if (response.data.data.token) this.setToken(response.data.data.token);
          this.$bvModal.hide("modal-welcome");
          this.$bvModal.hide("modal-registration");
          this.$bvModal.hide("modal-registration-otp");
          this.$bvModal.show("modal-registration-success");
        }

        this.websocketAttendance();
        this.websocketCategory();
        this.websocketDaily();
        this.websocketDailyAttendance();
      },
    });
  }
}
